export function isAbortLikeError(error) {
  const name = String(error?.name || '').toLowerCase();
  const message = String(error?.message || error || '').toLowerCase();
  return name === 'aborterror'
    || name === 'timeouterror'
    || message.includes('aborted')
    || message.includes('abort')
    || message.includes('timed out')
    || message.includes('timeout');
}

export function normalizeRequestError(error, { timedOut = false, offline = false } = {}) {
  if (offline) {
    const normalized = new Error('Нет соединения с интернетом');
    normalized.name = 'NetworkError';
    return normalized;
  }
  if (timedOut || isAbortLikeError(error)) {
    const normalized = new Error('Сервер не ответил вовремя. Попробуй ещё раз');
    normalized.name = 'TimeoutError';
    return normalized;
  }
  if (String(error?.name || '') === 'TypeError') {
    const normalized = new Error('Не удалось связаться с сервером');
    normalized.name = 'NetworkError';
    return normalized;
  }
  return error instanceof Error ? error : new Error(String(error || 'Ошибка соединения'));
}

export function isTransientRequestError(error) {
  const status = Number(error?.status || 0);
  return isAbortLikeError(error)
    || ['NetworkError', 'TypeError'].includes(String(error?.name || ''))
    || status === 408
    || status === 429
    || status >= 500;
}

export function shouldRetryRequest(method, error, attempt, maxAttempts) {
  return String(method || 'GET').toUpperCase() === 'GET'
    && attempt < maxAttempts
    && isTransientRequestError(error);
}

export function requestRetryDelay(attempt) {
  return Math.min(1000, 180 * Math.max(1, Number(attempt) || 1));
}
